import React, { useState } from 'react';
import { Modal, Button, message } from 'antd';
import { useTranslation } from 'react-i18next';
import httpClient from '../utils/HttpClient';
import { SUBSCRIPTIONS_PAYMENT_URL, COURSE_PAYMENT_URL, PROFILE_INFO_URL, COURSE_PRO_PURCHASES_URL } from '../constants/Url';
import { useDispatch, useSelector } from 'react-redux';
import { loginSuccessAction } from '../modules/auth/actions';
import { storageKeys } from '../constants/storage';

const OrderShipperModal = ({ open, onCancel, isOrderModalOpen, setIsOrderModalOpen, order }) => {
  const { t } = useTranslation();

  const handleOpenPaymentModal = () => {
    setIsOrderModalOpen(true);
  };

  return (
    <>
      <Modal
        open={isOrderModalOpen}
        onCancel={() => setIsOrderModalOpen(false)}
        footer={null}
        title={t('text_order_shipped')}
        closable={true}
        width={700}
        centered
        styles={{ body: { padding: '24px', borderRadius: '12px' }, header: { textAlign: 'center' } }}
      >
        <div className="flex flex-col gap-4 mt-1">
          <div className="flex gap-8 p-4 border border-gray-100 rounded-lg bg-gray-50/30">
            <div className="flex-1 flex flex-col gap-2">
              <div className="font-medium text-gray-800 mb-2 flex items-center gap-2">
                {t("text_receiver_info")}
              </div>
              <div className="flex text-sm">
                <span className="text-gray-500 w-24">{t("text_receiver_name")}:</span>
                <span className="text-gray-700">{order?.shippingInfo?.recipientName || ""}</span>
              </div>
              <div className="flex text-sm">
                <span className="text-gray-500 w-24">{t("text_phone_number")}: </span>
                <span className="text-gray-700">{order?.shippingInfo?.phone?.number || ""}</span>
              </div>
              <div className="flex text-sm">
                <span className="text-gray-500 w-24">{t("text_receiver_address")}: </span>
                <span className="text-gray-700">
                  {order?.shippingInfo ? 
                    `${order.shippingInfo.province || ''} ${order.shippingInfo.city || ''} ${order.shippingInfo.district || ''} ${order.shippingInfo.addressLine1 || ''} ${order.shippingInfo.addressLine2 || ''}`.replace(/\s+/g, ' ').trim() 
                    : ""}
                </span>
              </div>
            </div>
            
            <div className="flex-1 flex flex-col gap-2">
              <div className="font-medium text-gray-800 mb-2">
                {t("text_purchase_info")}
              </div>
              <div className="flex text-sm">
                <span className="text-gray-500 w-24">{t("text_user_id")}: </span>
                <span className="text-gray-700">{order?.memberNo || ""}</span>
              </div>
              <div className="flex text-sm">
                <span className="text-gray-500 w-24">{t("text_paid_time")}: </span>
                <span className="text-gray-700">{new Date(order?.orderedTS).toLocaleString() || ""}</span>
              </div>
            </div>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default OrderShipperModal;
